import { useEffect, useState } from 'react';
import {
  routeConstant,
  toastTheme,
  toastType,
  otherUserMessage,
} from '../../constants/app.constants';
import styles from './styles.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { LeftOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import { forgotPassword } from '../../redux/thunks/account';
import { showAlert } from '../../utils/helpers/toastify';
import { accountActionTypes } from '../../redux/actionTypes';
import { pushToLink } from '../../utils/helpers/global';
import headerLogo from '../../assets/HomePage/headerLogo.svg';
import linkSent from '../../assets/HomePage/linkSent.svg';
import InputField from '../../components/InputField/InputField';
import { GradientButton } from '../../components/GradientButton/GradientButton';
import DoubleCircleLoader from '../../components/DoubleCircleLoader/Index';

const ForgotPassword = (props) => {
  const [form] = Form.useForm();
  const [details, setDetails] = useState({ email: '' });
  const [linkSentView, setLinkSentView] = useState(false);
  const [wait, setWait] = useState(false);
  const {
    forgotPassword: forgotPasswordState,
    error,
    loading: isLoading,
  } = useSelector((state) => state.account);
  const dispatch = useDispatch();

  useEffect(() => {
    if (error) {
      form.setFields([
        {
          name: 'email',
          errors: [error],
        },
      ]);
      setWait(false);
    }
    if (forgotPasswordState.message) {
      setLinkSentView(true);
      setWait(false);
    }
    return () => {
      dispatch({ type: accountActionTypes.REMOVE_FORGOT_PASSWORD_DATA });
    };
  }, [error, forgotPasswordState.message]);
  const handleChange = (e) => {
    if (e.email) setDetails({ ...details, email: e.email });
  };
  const loginHandler = () => {
    setLinkSentView(false);
    pushToLink(props.history, routeConstant.USER_LOGIN_PATH);
  };
  const onSubmit = () => {
    if (details.email) {
      dispatch(forgotPassword({ payload: details }));
    }
    setWait(true);
  };

  return (
    <div className={styles.container_}>
      <div>
        <img src={headerLogo} alt="Header logo" className={styles.headerLogo} />
        {wait && <DoubleCircleLoader />}
        {!linkSentView ? (
          <>
            <div>
              <p>Forgot your Password?</p>
            </div>
            <div>Enter your registered email to receive a password reset link.</div>
            <div className={styles.formbox}>
              <Form
                form={form}
                name="normal_login"
                className={`login-form ${styles.forgetForm}`}
                layout="vertical"
                requiredMark={false}
                onFinish={onSubmit}
                onValuesChange={handleChange}
              >
                <InputField
                  name="email"
                  label="Email"
                  type="text"
                  rules={[
                    {
                      required: true,
                      message: otherUserMessage.inputEmailAddress,
                    },
                    {
                      type: 'email',
                      message: 'Please input valid email!',
                    },
                  ]}
                  form={form}
                />
                <Form.Item>
                  <GradientButton htmlType="submit" disabled={!details.email || wait}>
                    Submit
                  </GradientButton>
                </Form.Item>
              </Form>
            </div>
          </>
        ) : (
          <>
            <div>
              <p>Link Sent!</p>
            </div>
            <div>
              <img src={linkSent} alt="Link Sent Icon" className={styles.linkSentImg} />
            </div>
            <p className={styles.linkSentText}>
              We’ve sent a link to your registered email address. Please follow the instructions in
              the email to reset your password.
            </p>
          </>
        )}
        <div onClick={loginHandler} className={styles.backToLogin}>
          <LeftOutlined style={{ color: 'var(--link-text-color)', marginRight: '5px' }} />
          <span>Back to login</span>
        </div>
      </div>
    </div>
  );
};
export default ForgotPassword;
